import React, { useEffect } from "react";
import { MapPurpose } from "../../../widgets/google-maps/MapComponents/GoogleMapProps";
import { GoogleMapRaw } from "../../../widgets/google-maps/MapComponents/GoogleMapRaw";
import { MapMarkers } from "../../../widgets/google-maps/MapMarkers";
import appstore from "../../../appStore";
import { GeoPoint } from "../../Location/Entities";
import { useAppState } from "../../../Redux/ReduxHooks";
import { BookingStatus } from "../../../Services/BookingEntities";

/**
 * Component to display the map with the route and the car location. This is just a placeholder for now and will be implemented in the future.
 */
export const TrackingMap: React.FC = () => {

    // This component opens only if PhoneToCnp.Booking is non-null.
    const bookingDetails = useAppState(state => state.PhoneToCnp.Booking)!;

    useEffect(() => {
        if (bookingDetails.TrackingInfo.BookingStatusID != BookingStatus.Accepted && bookingDetails.TrackingInfo.BookingStatusID != BookingStatus.PickedUp) return;
    }, [bookingDetails]);

    if (bookingDetails.TrackingInfo.BookingStatusID != BookingStatus.Accepted && bookingDetails.TrackingInfo.BookingStatusID != BookingStatus.PickedUp) return null;

    /** 
     *  Gets the vehicle location for the Taxi map marker. 
     *  It will be undefined (no marker) when there is no Taxi assigned or its location isn't known.
     */
    function GetTaxiMarkerLocation(): GeoPoint | undefined {

        const vehicleLocation = bookingDetails.TrackingInfo.VehicleLocation;
        if (!vehicleLocation) return undefined;

        const result: GeoPoint = {
            latitude: vehicleLocation.Latitude,
            longitude: vehicleLocation.Longitude,
        };

        return result;
    }

    /** Normally centered on the Taxi. */
    function GetMapCenter(): GeoPoint {

        const taxiLocation = GetTaxiMarkerLocation();
        if (taxiLocation) return taxiLocation;

        // fallback (not expected)
        return appstore.getState().location.reliableLocation.value.geoPoint;
    }

    /** The list of locations of the booking to be displayed in the map. */
    function GetLocations() {

        // very rarely, some locations may not have GeoPoints when geopoints are not available in the database.
        const locationsWithGeoPoints = [
            {
                GeoPoint: {
                    Latitude: bookingDetails.Pickup.Latitude,
                    Longitude: bookingDetails.Pickup.Longitude
                }
            },
            {
                GeoPoint: {
                    Latitude: bookingDetails.DropOff.Latitude,
                    Longitude: bookingDetails.DropOff.Longitude
                }
            }
        ];
        if (locationsWithGeoPoints.length === 0) return null;

        const locationsForMap = locationsWithGeoPoints.map(location => {
            return {
                latitude: location.GeoPoint!.Latitude,
                longitude: location.GeoPoint!.Longitude,
            }
        });

        return locationsForMap;
    }

    return (
        <div className="tracking-map-container">
            <GoogleMapRaw
                mapCenter={GetMapCenter()}
                zoom={15}
                vehicleLocation={GetTaxiMarkerLocation()}
                carNumber={bookingDetails.TrackingInfo.CarNumber}
                PickupMarker={MapMarkers.PickupLocation}
                PlannedRoute={null}
                Purpose={MapPurpose.BookingWidget}
                Locations={GetLocations()}
            />
        </div>
    )
}